var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlackCloseModal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "black_close_modal",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "BG",
    width: 28,
    height: 28,
    fill: "#191816",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M.513,17.012a1.751,1.751,0,0,1-.12-2.343l.12-.132L6.288,8.763.513,2.988A1.75,1.75,0,0,1,2.855.393l.132.12L8.763,6.288,14.538.513a1.75,1.75,0,0,1,2.595,2.343l-.12.132L11.237,8.763l5.775,5.775a1.75,1.75,0,0,1-2.343,2.595l-.132-.12L8.763,11.237,2.988,17.012a1.75,1.75,0,0,1-2.475,0Z",
    transform: "translate(5.237 5.238)",
    fill: "#191816"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCloseModal);
export default __webpack_public_path__ + "static/media/black_close_modal.9e230f24cf86114b25ebc6a5e61eaa96.svg";
export { ForwardRef as ReactComponent };